import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Drawer from "react-modern-drawer";
import { HiMenu } from "react-icons/hi";
import onTrackImage from "../../images/logo/ontrack-logo-removebg-preview.png";
import "react-modern-drawer/dist/index.css";
import { useSelector } from "react-redux";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const userData = useSelector((state) => state.auth);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const isActiveLink = (path) =>
    location.pathname === path ? "text-blue-400 font-bold" : "";

  return (
    <nav className="bg-[#221f3a] fixed top-0 left-0 right-0 z-50 h-24">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-16 py-6">
        <div className="flex items-center justify-between gap-8">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src={onTrackImage}
              alt="ontrack Logo"
              className="mr-2 w-40 h-auto"
            />
          </div>

          {/* Desktop Links */}
          <ul className="hidden lg:flex space-x-6 text-white xl:whitespace-nowrap">
            <li>
              <Link
                to="/"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/"
                )}`}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/ai-literacy-assessment"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/ai-literacy-assessment"
                )}`}
              >
                AI Literacy Assessment
              </Link>
            </li>
            <li>
              <Link
                to="/ai-job-assessment"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/ai-job-assessment"
                )}`}
              >
                AI Job Assessment
              </Link>
            </li>
            <li>
              <Link
                to="/ai-career-mentors"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/ai-career-mentors"
                )}`}
              >
                AI Career Mentors
              </Link>
            </li>
            <li>
              <Link
                to="/skilling"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/skilling"
                )}`}
              >
                Skilling
              </Link>
            </li>
            {/* <li>
              <Link
                to="/community"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/community"
                )}`}
              >
                Community
              </Link>
            </li> */}
            {/* <li>
              <Link
                to="/jobs"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/jobs"
                )}`}
              >
                Jobs
              </Link>
            </li> */}
            {/* <li>
              <Link
                to="/resources"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/resources"
                )}`}
              >
                Resources / News
              </Link>
            </li> */}
            <li>
              <Link
                to="/events"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/events"
                )}`}
              >
                Resources Hub
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/pricing"
                )}`}
              >
                Pricing
              </Link>
            </li>
            {/* <li>
              <Link
                to="/faqs"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/faqs"
                )}`}
              >
                FAQs
              </Link>
            </li> */}
          </ul>

          {/* Sign Up / Login Button */}
          <div className="hidden lg:block">
            {userData.token !== null ? (
              <Link
                to="/dashboard/home"
                className="bg-custom-gradient text-white w-full py-2 rounded-full transition-all duration-300 ease-in-out whitespace-nowrap p-3 hover:shadow-lg hover:-translate-y-1 hover:opacity-90"
              >
                My Dashboard
              </Link>
            ) : (
              <Link
                to="/auth/login"
                className="bg-custom-gradient text-white w-full py-2 rounded-full whitespace-nowrap p-3 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:opacity-90"
              >
                Sign Up / Login
              </Link>
            )}
          </div>

          {/* Mobile Menu Button - Always Visible */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={toggleDrawer}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-blue-400 focus:outline-none"
            >
              <HiMenu className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {/* Drawer for Mobile View */}
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        className="!bg-gray-800"
      >
        <div className="p-4 h-full text-white">
          <div className="flex items-center justify-between mb-8">
            <img
              src={onTrackImage}
              alt="OnTrack Careers Logo"
              className="mr-2 w-28 h-auto"
            />
            <button onClick={toggleDrawer} className="text-lg text-white">
              ✕
            </button>
          </div>

          <ul className="flex flex-col space-y-4">
            <li>
              <Link
                to="/"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/"
                )}`}
                onClick={toggleDrawer}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/ai-literacy-assessment"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/ai-literacy-assessment"
                )}`}
                onClick={toggleDrawer}
              >
                AI Literacy Assessment
              </Link>
            </li>
            <li>
              <Link
                to="/ai-job-assessment"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/ai-job-assessment"
                )}`}
                onClick={toggleDrawer}
              >
                AI Job Assessment
              </Link>
            </li>
            <li>
              <Link
                to="/ai-career-mentors"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/ai-career-mentors"
                )}`}
                onClick={toggleDrawer}
              >
                AI Career Mentors
              </Link>
            </li>
            <li>
              <Link
                to="/skilling"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/skilling"
                )}`}
                onClick={toggleDrawer}
              >
                Skilling
              </Link>
            </li>
            {/* <li>
              <Link
                to="/community"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/community"
                )}`}
                onClick={toggleDrawer}
              >
                Community
              </Link>
            </li> */}
            {/* <li>
              <Link
                to="/jobs"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/jobs"
                )}`}
                onClick={toggleDrawer}
              >
                Jobs
              </Link>
            </li> */}
            {/* <li>
              <Link
                to="/resources"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/resources"
                )}`}
                onClick={toggleDrawer}
              >
                Resources / News
              </Link>
            </li> */}
            <li>
              <Link
                to="/events"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/events"
                )}`}
                onClick={toggleDrawer}
              >
                Resources Hub
              </Link>
            </li>
            <li>
              <Link
                to="/pricing"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/pricing"
                )}`}
                onClick={toggleDrawer}
              >
                Pricing
              </Link>
            </li>
            {/* <li>
              <Link
                to="/faqs"
                className={`hover:text-blue-400 transition-colors ${isActiveLink(
                  "/faqs"
                )}`}
              >
                FAQs
              </Link>
            </li> */}
          </ul>

          <div className="mt-8">
            {userData.token !== null ? (
              <Link
                to="/dashboard/home"
                className="bg-custom-gradient text-white w-full py-2 rounded-full transition-all duration-300 ease-in-out whitespace-nowrap p-3 hover:shadow-lg hover:-translate-y-1 hover:opacity-90"
              >
                My Dashboard
              </Link>
            ) : (
              <Link
                to="/auth/login"
                className="bg-custom-gradient text-white w-full py-2 rounded-full whitespace-nowrap p-3 transition-all duration-300 ease-in-out hover:shadow-lg hover:-translate-y-1 hover:opacity-90"
              >
                Sign Up / Login
              </Link>
            )}
          </div>
        </div>
      </Drawer>
    </nav>
  );
};

export default Navbar;
